

import { useState } from 'react';
import { calcNds, numberWithSpaces } from '../../../../utils';
import { Column, Row, WhiteBlock } from '../../../Basic/Blocks';
import { DropDown } from '../../../Basic/Elements';
import { Text, TextGrey } from '../../../Basic/WrapsStyle';
import styles from './styles.module.scss';

const CommissionNdsBlock = ({ card = {}, isExpress = false, market }) => {
  const [hover, setHover] = useState(false);

  return (
    <div className={styles.commission}>
      <TextGrey fontSize={12} onMouseOver={() => setHover(true)} onMouseLeave={() => setHover(false)}>
        {numberWithSpaces(Math.ceil(isExpress ? card.commission?.express_common?.rub : card.commission?.common?.rub))}
      </TextGrey>

      {hover && (
        <DropDown styles={styles.all_commission} close={() => setHover(false)}>
          <>
            <WhiteBlock styles={styles.init}>
              <Column>
                {(market === 'OZON' || market === 'OZON') && (
                  <Row>
                    <TextGrey className={styles.grey_text}>Объемный вес:</TextGrey>
                    <Text className={styles.text}>{card.volume_weight} кг</Text>
                  </Row>
                )}
                {market === 'WB' && (
                  <Row>
                    <TextGrey className={styles.grey_text}>Скидка {card.discount.percent}%:</TextGrey>
                    <Text className={styles.text}>{card.discount.rub} ₽</Text>
                  </Row>
                )}
                {/* {market !== 'KUPER' && (
                  <Row>
                    <TextGrey className={styles.grey_text}>Объем, л:</TextGrey>
                    <Text className={styles.text}>
                      {card?.sizes_package?.volume ? card?.sizes_package?.volume : 'не указан'}
                    </Text>
                  </Row>
                )} */}
                <Row>
                  <TextGrey className={styles.grey_text}>Эквайринг {card.commission?.acquaring?.percent}%:</TextGrey>
                  <Text className={styles.text}>{card.commission?.acquaring?.rub} ₽</Text>
                </Row>

                {market === 'YANDEX' && (
                  <>
                    <Row>
                      <TextGrey className={styles.grey_text}>Приём платежа покупателя:</TextGrey>
                      <Text className={styles.text}>{card.commission?.accepting_payment?.rub} ₽</Text>
                    </Row>
                    {card.commission?.ours?.wholesale_packaging_rub > 0 && <Row>
                      <TextGrey className={styles.grey_text}>
                        Буст продвижение {card.commission?.boost?.percent}%:
                      </TextGrey>
                      <Text className={styles.text}>{card.commission?.boost?.rub} ₽</Text>
                    </Row>}
                  </>
                )}
                <Row>
                  <TextGrey className={styles.grey_text}>
                    Комиссия {card.commission?.market_commission?.percent}%:
                  </TextGrey>
                  <Text className={styles.text}>{card.commission?.market_commission?.rub} ₽</Text>
                </Row>

                {(market === 'WB' || market === 'OZON') &&
                  !isExpress &&
                  card.commission?.increased_commission?.percent > 0 && (
                    <Row>
                      <TextGrey className={styles.grey_text}>
                        {`Повышенная комиссия ${card.commission?.increased_commission?.percent}%`}
                        {market === 'WB' ? ` (${Math.ceil(card.commission?.increased_commission?.percent / 0.15) + 15}ч.):` : `:`}
                      </TextGrey>
                      <Text className={styles.text}>{card.commission.increased_commission?.rub} ₽</Text>
                    </Row>
                  )}

                {market === 'MM' && (
                  <Row>
                    <TextGrey className={styles.grey_text}>Кешбэк {card.commission.cashback?.percent}%:</TextGrey>
                    <Text className={styles.text}>{card.commission.cashback?.rub} ₽</Text>
                  </Row>
                )}

                {market !== 'KUPER' && (card.commission?.sorting?.rub) > 0 && (
                  <Row>
                    <TextGrey className={styles.grey_text}>Обработка отправления на СЦ:</TextGrey>
                    <Text className={styles.text}>
                      {isExpress ? card.commission.sorting?.express_rub || 0 : card.commission?.sorting?.rub || 0} ₽
                    </Text>
                  </Row>
                )
                }

                {(market === 'OZON' || market === 'MM' || market === 'YANDEX') && (
                  <>
                    {isExpress ? (
                      <Row>
                        <TextGrey className={styles.grey_text}>Доставка:</TextGrey>
                        <Text className={styles.text}>{card.commission?.delivery_client?.express_rub} ₽</Text>
                      </Row>
                    ) : (
                      <>
                        <Row>
                          <TextGrey className={styles.grey_text}>
                            {`Логистика`}:<br />
                          </TextGrey>

                          <Text className={styles.text}>{card.commission?.delivery_sort_center?.rub} ₽</Text>
                        </Row>

                        <Row>
                          <TextGrey className={styles.grey_text}>
                            {`Последняя миля, ${card.commission?.delivery_client?.percent}%`}:<br />
                            {/*        (min - {commission.MILE_MIN} ₽, max - {commission.MILE_MAX} ₽): взять инфу с базы мп*/}
                          </TextGrey>
                          <Text className={styles.text}>{card.commission?.delivery_client?.rub} ₽</Text>
                        </Row>
                      </>
                    )}
                  </>
                )}
                {market === 'WB' && (
                  <>
                    <>
                      <Row>
                        <TextGrey className={styles.grey_text}>
                          {`Доставка (${card?.sizes_package?.volume ? card?.sizes_package?.volume : '-'} л)`}:<br />
                        </TextGrey>

                        <Text className={styles.text}>{card.commission?.delivery?.rub} ₽</Text>
                      </Row>
                      {card.commission?.ours?.transit_rub > 0 && (
                        <Row>
                          <TextGrey className={styles.grey_text}>Транзит:</TextGrey>
                          <Text className={styles.text}>{card.commission?.ours?.transit_rub} ₽</Text>
                        </Row>
                      )}
                      {card.commission?.ours?.extra_rub > 0 && (
                        <Row>
                          <TextGrey className={styles.grey_text}>Доп. расходы:</TextGrey>
                          <Text className={styles.text}>{card.commission?.ours?.extra_rub} ₽</Text>
                        </Row>
                      )}
                    </>
                  </>
                )}

                {card.commission?.ours?.wholesale_packaging_rub > 0 && (
                  <Row>
                    <TextGrey className={styles.grey_text}>Мелкооптовая упаковка:</TextGrey>
                    <Text className={styles.text}>{card.commission?.ours?.wholesale_packaging_rub} ₽</Text>
                  </Row>
                )}
                {card.commission?.ours?.box_rub > 0 && (
                  <Row>
                    <TextGrey className={styles.grey_text}>Короб:</TextGrey>
                    <Text className={styles.text}>{card.commission?.ours?.box_rub} ₽</Text>
                  </Row>
                )}

                <Row>
                  <TextGrey className={styles.grey_text}>Расходы на упаковку:</TextGrey>
                  <Text className={styles.text}>{card.commission?.ours?.package_rub} ₽</Text>
                </Row>
                <Row>
                  <TextGrey className={styles.grey_text}>{`Налог НДС ${'22'}:`}</TextGrey>
                  <Text className={styles.text} style={{ color: 'red' }}>
                    {isExpress ? card.commission?.nds?.express_rub : card.commission?.nds?.rub} ₽
                  </Text>
                </Row>
                <Row>
                  <TextGrey className={styles.grey_text}>НДС товара {card.nds ? card.nds : '0'} %:</TextGrey>
                  <Text className={styles.text} style={{ color: 'red' }}>
                    {calcNds(card.purchase * (card.quantity || 1) * (card.min_quantity || 1), card.nds || 0)} ₽
                  </Text>
                </Row>
                <Row>
                  <TextGrey className={styles.grey_text}>Налог НДФЛ {card.commission?.tax?.percent}%:</TextGrey>
                  <Text className={styles.text} style={{ color: 'red' }}>
                    {isExpress ? card.commission?.tax?.express_rub : card.commission?.tax?.rub} ₽
                  </Text>
                </Row>
              </Column>
            </WhiteBlock>
          </>
        </DropDown>
      )}
    </div>
  );
};

export default CommissionNdsBlock;
